import { BaseServices, HttpMethod } from '@services/base'

import { BridgeService } from './bridge'

export interface ParameterResponse {
  id: number
  name: string
  description: string
  value: string
  active: boolean
  createdAt: string
  updatedAt: string
  modifiedBy: string
}

export default (name: string, accessToken?: string) => {
  const pathname = accessToken
    ? `${process.env.REACT_APP_GET_PARAMETER_WEB}/${encodeURIComponent(name)}`
    : `${process.env.REACT_APP_GET_PARAMETER_APP}/${encodeURIComponent(name)}`

  const method = HttpMethod.GET
  const host = process.env.REACT_APP_API_HOST
  const headers: Record<string, string> = {}

  if (BridgeService.isBrowser() && accessToken) {
    headers.Authorization = `Bearer ${accessToken}`
  }

  return BaseServices.request<ParameterResponse>({
    headers,
    pathname,
    method,
    host,
  })
}
